import { ROLE, useClient } from '@/features/Clients';
import { computed } from 'vue';
import { hasRelationshipWithAPartner } from '@/features/Sparten/shared/renderConditions/property/sharedRenderConditions';

export const hasMitversichertePerson = computed(() => {
  const { client, isPersistedClient } = useClient(ROLE.MITVERSICHERTER_PARTNER);

  return (
    (client.value.isDirty || isPersistedClient.value) &&
    hasRelationshipWithAPartner.value
  );
});
